<h2>Create a video</h2>
<video autoplay id="localVideo"
       width="640"
       height="480"></video>
<div class="card-container" *ngIf="recorderService.isRecorderActive">
  <div id="circle" class="blinking"></div>&nbsp; &nbsp;
  <h3 id="recordingText">Recording</h3>
</div>
<div class="card-container">
    <!--  <div class="card card-small" (click)="startRecord()" tabindex="0">-->
    <!--    <span>{{recorderService.isRecorderActive ? 'Stop recording' : 'Start recording'}}</span>-->
    <!--  </div>-->
    <div class="card card-small" tabindex="0">
        <span>{{ recorderService.isRecorderActive ? 'Stop recording' : 'Start recording' }}</span>
    </div>
</div>
<div style="display: flex;justify-content: center">
    <span style="color: red;">It has been deactivated.</span>
</div>
<div *ngIf="recorderService.currentUrl && recorderService.currentBlob">
  <hr/>
  <h4>Preview video</h4>
  <video [src]="recorderService.currentUrl" height="300" controls></video>
  <hr/>
  <div class="card-container">
    <div class="card card-small" (click)="upload()" tabindex="0">
      <span>Upload & analyze video</span>
    </div>
  </div>
  <div class="card-container" *ngIf="isBusy">
    <div class="lds-dual-ring"></div>
  </div>
</div>
<div *ngIf="downloadUrl">
  <hr/>
  <h4>Analyzed video</h4>
  <video [src]="downloadUrl" *ngIf="downloadUrl" height="300" controls></video>
  <br/><br/>
  <div class="card-container">
    <div class="card card-small" (click)="download()" tabindex="0">
      <span>Download video</span>
    </div>
    <div class="card card-small" (click)="downloadCsv()" tabindex="0">
      <span>Download csv</span>
    </div>
  </div>
</div>
